module.exports = __webpack_public_path__ + "img/logo.b693a928.png";